import React, { useState } from 'react';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { useDefaultMissionControlVersion } from '@v2/hooks';
import { Button } from '@v2/components';
import { EditMissionControlVersionModal } from '../EditMissionControlVersionModal';
import { DefaultMissionControlVersionHeaderProps } from './types';
import { styles } from './styles';

const formatReleaseDate = (releaseDate: string): string =>
  moment.utc(releaseDate).local().format('M/D/YYYY LT');

const DefaultMissionControlVersionHeader: React.FC<DefaultMissionControlVersionHeaderProps> = ({
  canEditVersion = false,
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { version, loading, error, refetch } = useDefaultMissionControlVersion();

  if (loading) {
    return (
      <div className={styles.container}>
        <h3 className={styles.title}>Default Mission Control Version</h3>
        <p className={styles.value}>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.container}>
        <h3 className={styles.title}>Default Mission Control Version</h3>
        <p className={styles.value}>Error loading version</p>
      </div>
    );
  }

  if (!version) {
    return null;
  }

  const versionText = version.version;
  const releaseDateText = version.releaseDate ? formatReleaseDate(version.releaseDate) : 'N/A';
  const descriptionText =
    version.description && version.description !== '' ? version.description : 'N/A';

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Default Mission Control Version</h3>
      <div className={styles.row}>
        <div className={styles.field}>
          <span className={styles.label}>Version:</span>
          <span className={styles.value}>{versionText}</span>
          {canEditVersion && (
            <Button
              variant="ghost-primary"
              size="sm"
              onClick={() => setIsEditModalOpen(true)}
              aria-label="Edit default version"
              icon={<FontAwesomeIcon icon={faEdit} />}
            />
          )}
        </div>
        <span className={styles.divider} aria-hidden />
        <div className={styles.field}>
          <span className={styles.label}>Release Date:</span>
          <span className={styles.value}>{releaseDateText}</span>
        </div>
        <span className={styles.divider} aria-hidden />
        <div className={styles.field}>
          <span className={styles.label}>Description:</span>
          <span className={styles.value}>{descriptionText}</span>
        </div>
      </div>
      {canEditVersion && (
        <EditMissionControlVersionModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          currentVersion={version.version}
          onSuccess={refetch}
        />
      )}
    </div>
  );
};

export default DefaultMissionControlVersionHeader;
